import * as React from 'react';

export type WixDesignSystemsMaskingProviderProps = {
  children?: React.ReactNode;
};

export type WixDesignSystemsMaskingContextProps = {
  maskingClassNames: string;
};
